import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import {
    Modality,
    PresentingProblem,
    PublicProfileSettings,
    TherapyType,
} from "../../domain/types";

/**
 * The therapist's own settings, over the *authenticated* client — unlike the
 * directory read, which deliberately uses a client with no auth interceptor.
 */
const BASE = "/therapists/me/public-profile";

export interface CopyPayload {
    headline: string | null;
    public_bio: string | null;
    city: string | null;
    modalities: Modality[];
    languages: string[];
    presenting_problems: PresentingProblem[];
    custom_presenting_problems: string[];
    custom_therapy_types: string[];
    therapy_types: TherapyType[];
}

export interface ContactPayload {
    public_email: string | null;
    public_phone: string | null;
    public_website: string | null;
}

export interface VisibilityPayload {
    show_photo: boolean;
    show_therapy_types: boolean;
    show_availability: boolean;
    show_locations: boolean;
    show_contact: boolean;
}

type Settings = Promise<AxiosResponse<PublicProfileSettings>>;

export const PublicProfileSettingsAPI = {
    get: (): Settings => apiClient.get(BASE),
    updateCopy: (payload: CopyPayload): Settings => apiClient.put(BASE, payload),
    updateContact: (payload: ContactPayload): Settings =>
        apiClient.put(`${BASE}/contact`, payload),
    updateVisibility: (payload: VisibilityPayload): Settings =>
        apiClient.put(`${BASE}/visibility`, payload),
    publish: (): Settings => apiClient.post(`${BASE}/publish`),
    unpublish: (): Settings => apiClient.post(`${BASE}/unpublish`),

    photoUploadUrl: (
        contentType: string,
        sizeBytes: number,
    ): Promise<AxiosResponse<{ upload_url: string; object_name: string }>> =>
        apiClient.post(`${BASE}/photo/upload-url`, {
            content_type: contentType,
            size_bytes: sizeBytes,
        }),
    confirmPhoto: (objectName: string): Settings =>
        apiClient.post(`${BASE}/photo/confirm`, { object_name: objectName }),
    removePhoto: (): Settings => apiClient.delete(`${BASE}/photo`),
};
